import React from "react";
import Layout from "../components/Layout";
import Section from "../components/Section";
import { ButtonLink } from "../components/Buttons";
import { 
  BorderDiv,
  HeaderH1, 
  HeaderH3,
  SectionH2,
  SectionH4,
  SectionP,
} from "../helpers/styledComponents";
import { Grid, Button } from "semantic-ui-react";
import styled from "styled-components";

const headerContent = (
  <>
    <HeaderH1>Resources and Events</HeaderH1>
    <div style={{maxWidth: "900px", margin: "auto"}}>
      <HeaderH3>Civic Alliance equips businesses with nonpartisan tools, resources, and programming to support civic participation.</HeaderH3>
      <HeaderH3>Explore practical guides, election resources, and opportunities to strengthen your company's civic engagement efforts.</HeaderH3>
    </div>
  </>
);

const SectionH4Big = styled(SectionH4)`
  font-size: 1.5rem;
`;

const StyledUL = styled.ul`
  font-size: 1.25em;
  list-style: outside disc;
  margin-left: 2em;
  margin-top: 1em;
  margin-bottom: 0;
  padding-left: 0; 

  li+li {
    margin-top: .25em;
  }
`;

export default () => {
  return (
    <Layout 
      mode="dark" 
      headerContent={headerContent}
      title="Member Resources and Events | Civic Alliance"
    >
      <Section mode="light" extraMargin>
        <SectionH2>Resources &amp; Toolkits</SectionH2>
          <Grid columns={2} stackable>
            <Grid.Column style={{ width: "45%", margin: "40px auto", padding: "30px", border: "1px solid black", borderRadius: "30px"}} textAlign="center">
              <SectionH4Big>2026 Election Guide</SectionH4Big>
              <SectionP center>
                A guide to help business leaders navigate the 2026 midterm elections, engage employees, and support nonpartisan civic participation.
              </SectionP>
              <Button style={{ color: "rgb(249, 249, 249)", backgroundColor: "rgb(10, 10, 10)" }} href="https://cvcallnce.com/election-guide-download" target="_blank">Get the Guide</Button>
            </Grid.Column>
            <Grid.Column style={{ width: "45%", margin: "40px auto", padding: "30px", border: "1px solid black", borderRadius: "30px"}} textAlign="center">
              <SectionH4Big>2026 Voter Need-to-Knows</SectionH4Big>
              <SectionP center>
                A voter-friendly resource covering essential election information, key dates, and steps to help voters prepare to cast their ballots in 2026.
              </SectionP>
              <Button style={{ color: "rgb(249, 249, 249)", backgroundColor: "rgb(10, 10, 10)" }} href="https://cvcallnce.com/voter-need-to-knows" target="_blank">Plan Your Vote</Button>
            </Grid.Column>
          </Grid>
          <SectionH4Big>Time Off to Vote Toolkit</SectionH4Big>
          <SectionP center>
            A resource outlining how companies develop, communicate, and implement workplace policies that give employees the time they need to vote.
            <br />
            <br />
            <ButtonLink mode="dark" to="https://cvcallnce.com/timetovote-download" newTab>Explore the Toolkit</ButtonLink>
          </SectionP>
          <div style={{ marginTop: "2.5rem" }}>
            <SectionH4Big>Civic Journey Pocket Guide</SectionH4Big>
            <SectionP center>
              The Civic Journey Pocket Guide is a clear, nonpartisan, tactical guide that will provide an overview of how your business can make a measurable impact.
              <br />
              <br />
              <ButtonLink mode="dark" to="https://cvcallnce.com/civicjourney-pocketguide" newTab>Start Your Civic Journey</ButtonLink>
            </SectionP>
          </div>
          <div style={{ marginTop: "2.5rem" }}>
            <SectionH4Big>Origin Stories: How to Build a Civics Program</SectionH4Big>
            <SectionP center>
              A set of case studies featuring insights and examples to help businesses establish, strengthen, and sustain civic engagement programs.
              <br />
              <br />
              <ButtonLink mode="dark" to="https://cvcallnce.com/origin-stories" newTab>Read the Stories</ButtonLink>
            </SectionP>
          </div>
          <div style={{ marginTop: "2.5rem" }}>
            <SectionH4Big>Civic Storylines Toolkit</SectionH4Big>
            <SectionP center>
              Our resource to help content creators authentically and impactfully integrate civic themes into their films, TV shows, podcast episodes and more! Developed in partnership with CAA, Comedy Central, MTV and Spotify.
              <br />
              <br />
              <ButtonLink mode="dark" to="/storylines" newTab>Get the Storylines Toolkit</ButtonLink>
            </SectionP>
          </div>
      </Section>
      <Section mode="dark" larger>
        <SectionH2>Civic Alliance Events</SectionH2>
        <SectionP>We support the business community with a range of in-person and virtual events featuring experts, business leaders, and nonprofit partners. The Civic Alliance community also offers opportunities for leaders to connect with their peers in the business sector.</SectionP>
        {/* Button href to be added here*/}
        <ButtonLink mode="light" to="https://cvcallnce.com/newsletter" newTab={true} center>Sign up for our newsletter to receive the latest event updates.</ButtonLink>
        <BorderDiv mode="dark" style={{ margin: "2.5rem auto 0" }}>
          <SectionP>Past event topics include:</SectionP>
          <StyledUL>
            <li>Civic Salon Dinner: Meeting Companies Where They Are</li>
            <li>Equipping Your Part-Time Employees with Time for Voting: Virtual Roundtable</li>
            <li>Tackling Misinformation Ahead of Election Day</li>
            <li>What to Expect This Election Season: Scenario Planning for Business Leaders</li>
          </StyledUL>
        </BorderDiv>
      </Section>
    </Layout>
  );
}